module.exports = __webpack_public_path__ + "img/log_new.45da0171.png";